import * as ko from "knockout";
import * as $ from "jquery";
let baoPager: KnockoutBindingHandler = {
    init: function (element, valueAccessor: () => any, allBindingsAccessor, viewModel, bindingContext) {
        $(element).after("<div>");
        ko.applyBindingsToNode($(element).next().get(0), {
            component: {
                name: "bao-pager",
                params: valueAccessor()
            }
        });
    }
};
ko.bindingHandlers["baoPager"] = baoPager;